import AppointmentList from './AppointmentList';
export default AppointmentList;